module.exports = __webpack_public_path__ + "static/media/neo-sans-light.181d371b.woff2";